import axios from 'axios'
import {
    MessageBox,
    Message
} from 'element-ui'
import router from '@/router'
import store from '../store/index'
/* import { getToken } from '@/utils/auth'; */

// 创建axios实例
const service = axios.create({
    //  baseURL: process.env.VUE_APP_BASE_API, //URL地址   环境变量文件 .env.development
    timeout: 50000, //超时
    // withCredentials: true,  //跨域时若要发生cookie,需要设置该选项
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // if(store.getters.token){
        //     // 设置令牌请求头
        //     config.headers['Authorization'] = getToken()
        // }
        return config;
    },
    error => {
        return Promise.reject(error)
    }

)

// 相应拦截
service.interceptors.response.use(
    // 通过自定义code 判定响应状态 也可以通过HTTP状态码判断
    response => {
        const res = response.data
        // 假设 10008 非法令牌  10012 其他客户端已经登陆 status
        if (res.code == 2) {
            // 重新登陆
            MessageBox.confirm(
                '登陆状态异常,请重新登陆',
                "确认登陆信息", {
                    confirmButtonText: '重新登陆',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                window.sessionStorage.clear()
                router.push('/login')
                /*  store.dispatch('user/resetToken')
                     .then(()=>{
                         location.reload()
                     }) */
            })
        }
        return res;

    },
    /*  */
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 404:
                    Message.error('资源开小差')
                    break
                case 500:
                    Message.error('服务器报错')
                    break
                default:
                    Message.error(error.response.statusText)
            }
        } else {
            // 请求超时或者网络有问题
            if (error.message.includes('timeout')) {
                Message.error('请求超时！请检查网络是否正常')
            } else {
                Message.error('请求失败，请检查网络是否已连接')
            }
        }
        return Promise.reject(error)
    }

)
/* export default service; */
export default {
    post(url, data, headers) {
        return service({
            method: 'post',
            url,
            data: data,
            headers: headers
        })
    },
    get(url, params, headers) {
        return service({
            method: 'get',
            url,
            params,
            headers: headers
        })
    },
    put(url, data) {
        return service({
            method: 'put',
            url,
            data
        })
    },
    detele(url, params) {
        return service({
            method: 'delete',
            url,
            params,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    blob(url, data) {
        return service({
            method: 'post',
            url,
            data,
            responseType: 'blob',
        })
    },
}